var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 5.5C11 8.53755 8.53755 11 5.5 11C2.46244 11 0 8.53755 0 5.5C0 2.46244 2.46244 0 5.5 0C8.53755 0 11 2.46244 11 5.5ZM1.00341 5.5C1.00341 7.9834 3.0166 9.9966 5.5 9.9966C7.9834 9.9966 9.9966 7.9834 9.9966 5.5C9.9966 3.0166 7.9834 1.00341 5.5 1.00341C3.0166 1.00341 1.00341 3.0166 1.00341 5.5Z",
    fill: "#5B6B79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.5 2C5.22385 2 5 2.22385 5 2.5V5.73335C5 5.73335 5 5.8637 5.06335 5.96175C5.10575 6.0449 5.17185 6.11715 5.2587 6.1673L7.5686 7.50095C7.80775 7.639 8.11355 7.55705 8.2516 7.3179C8.38965 7.07875 8.30775 6.77295 8.0686 6.6349L6 5.4406V2.5C6 2.22386 5.77615 2 5.5 2Z",
    fill: "#5B6B79"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.9b79ce90c3ad3dc56e90cb001cab15b8.svg";
export { ForwardRef as ReactComponent };